import { useEffect, useState } from "react";

/**
 * Returns `true` once the page is scrolled past `thresholdScreens` viewport
 * heights, and back to `false` when scrolled above it again. Used to fade the
 * floating CTAs out as the visitor scrolls down and fade them back in near the
 * top.
 *
 * @param thresholdScreens Multiplier of the viewport height. `1.4` hides after
 *   ~1.4 screens; `0` hides as soon as the user initiates any scroll.
 */
export function useHideOnScroll(thresholdScreens = 2): boolean {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const compute = () => {
      const threshold = window.innerHeight * thresholdScreens;
      setHidden(window.scrollY > threshold);
    };

    compute();
    window.addEventListener("scroll", compute, { passive: true });
    window.addEventListener("resize", compute);
    return () => {
      window.removeEventListener("scroll", compute);
      window.removeEventListener("resize", compute);
    };
  }, [thresholdScreens]);

  return hidden;
}
